import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  constructor() { }

  public getFormValidator(vm: any): FormValidator {
    let validator = new FormValidator(vm, this);
    return validator;
  }

  public getError(vm: any, fieldName: string): ValidationError {
    let e = _.find(vm.errors, (er) => er.fieldName === fieldName);
    return e;
  }

  public getErrorMessage(vm: any, fieldName: string): string {
    let e = _.find(vm.errors, (er) => er.fieldName === fieldName);
    return !e ? undefined : e.message;
  }

  public isValidEmail(email: string): boolean {

    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(email);

  }

}
export class FormValidator {

  constructor(private vm: IValidatedViewModel,
    private formValidationSerivce: FormValidationService) { }


  pushError(failed: boolean, name: string, message: string): boolean {
    if (failed) {
      this.vm.errors.push(new ValidationError(name, message));
      return false;
    }
    return true;
  }

  failsEmailFormat(value: any) {
    return value && value.length > 0 && !this.formValidationSerivce.isValidEmail(value);
  }

  public validateEmail(name: string, caption: string, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsEmailFormat(this.vm[name]) : validationFn();
    return this.pushError(failed, name, caption + ' must be a valid email (like myname@domain.com)');

  }


  failsRequired(value: any) {
    return !value || String(value).trim().length === 0;
  }
  public validateRequired(name: string, caption: string, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsRequired(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' is required');

  }

  failsAUState(value: any) {
    let states = ['VIC', 'NSW', 'TAS', 'QLD', 'WA', 'SA', 'NT'];
    return value && !_.find(states, (n: string) => n === String(value).toUpperCase());
  }

  public validateState(name: string, caption: string, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsAUState(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' must be a valid state');
  }

  failsAUPhone(value: any) {
    if (!value) {
      return false;
    }

    if (!this.isPhoneNoBracesFormat(value) &&
      !this.isPhoneLandlineFormat(value) &&
      !this.isPhoneMobileFormat(value)) { return true; }

    return false;
  }

  failsAUPhonePlus(value: any) {
    if (!value) {
      return false;
    }

    if (!this.isPhoneNoBracesFormat(value) &&
        !this.isPhoneLandlineFormat(value) &&
        !this.isAust1800Format(value) &&
        !this.isPhoneMobileFormat(value)) { return true; }

    return false;
  }

  failsAUMobilePhone(value: any) {
    if (!value) {
      return false;
    }

    if (!this.isMobileNoBracesFormat(value) &&
      !this.isMobileLandlineFormat(value) &&
      !this.isPhoneMobileFormat(value)) { return true; }

    return false;
  }

  isMobileNoBracesFormat(value: any) {

    if (!value || value.trim() === '') {
      return false;
    }

    let phone = String(value).replace(/\s/g, '');
    let reNoBraces = /^04\d{8}$/;
    let isNoBracesValid = reNoBraces.test(phone);

    return isNoBracesValid;

  }

  isMobileLandlineFormat(value: any) {
    if (!value || value.trim() === '') {
      return false;
    }
    let phone = String(value).replace(/\s/g, '');
    let reLandLine = /^\(04\)\d{8}$/;
    let isLandlineValid = reLandLine.test(phone);

    return isLandlineValid;
  }

  isPhoneNoBracesFormat(value: any) {

    if (!value || value.trim() === '') {
      return false;
    }

    let phone = String(value).replace(/\s/g, '');
    let reNoBraces = /^(02|04|03|07|08)\d{8}$/;
    let isNoBracesValid = reNoBraces.test(phone);

    return isNoBracesValid;

  }

  isPhoneLandlineFormat(value: any) {
    if (!value || value.trim() === '') {
      return false;
    }
    let phone = String(value).replace(/\s/g, '');
    let reLandLine = /^(\(02\)|\(03\)|\(04\)|\(07\)|\(08\))\d{8}$/;
    let isLandlineValid = reLandLine.test(phone);

    return isLandlineValid;
  }

  isPhoneMobileFormat(value: any) {
    
    if (!value || value.trim() === '') {
      return false;
    }

    let phone = String(value).replace(/\s/g, '');
    
    let reMobile = /^\(04\d{2}\)\d{6}$/;
    let isMobileValid = reMobile.test(phone);

    return isMobileValid;
  }

  isAust1800Format(value: any) {
    if (!value || value.trim() === '') {
      return false;
    }

    let phone = String(value).replace(/\s/g, '');

    let re1800 = /^1800\d{6}$/;
    let is1800Valid = re1800.test(phone);

    if (is1800Valid) {
      return true;
    }

    let re1300 = /^1300\d{6}$/;
    let is1300Valid = re1300.test(phone);

    if (is1300Valid){ 
      return true;
    }

    let re13 = /^13\d{4}$/;
    let is13Valid = re13.test(phone);

    if (is13Valid) {
      return true;
    }

    return false;
  }

  public formatPhone(value: string): string {

    let phone = this.phoneToNoBracesFormat(value);
    let formattedphone = this.formatNoBracesFormat(phone);

    return formattedphone;

  }

  formatNoBracesFormat(value: string): string {
    
    value = String(value).replace(/\s/g, '');

    let areacode = value.substring(0, 2);

    if (areacode === '04') {
      areacode = value.substring(0, 4);
      let phone1 = value.substring(4, 7);
      let phone2 = value.substring(7);
      return  areacode + ' ' + phone1 + ' ' + phone2;
    }
    else if(areacode === '18' || areacode === '13') {
       areacode = value.substring(0, 4);

      if(areacode==='1800' || areacode === '1300')
      {
          let phone1 = value.substring(4, 7);
          let phone2 = value.substring(7);

          return  areacode + ' ' + phone1 + ' ' + phone2;
      }
      else
      {
        areacode = value.substring(0, 2);
        let phone1 = value.substring(2);

        return  areacode + ' ' + phone1;
      }

    }
    else {
      let phone1 = value.substring(2, 6);
      let phone2 = value.substring(6);
      return '(' + areacode + ') ' + phone1 + ' ' + phone2;
    }
  }

  phoneToNoBracesFormat(value: string): string {
    let phone = String(value).replace(/(\s|\(|\))/g, '');
    return phone;
  }

  public validatePhone(name: string, caption: string, validationFn?: ValidationFunction): boolean {
    let failed = typeof validationFn !== 'function' ? this.failsAUPhone(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' must be a valid phone number (like 03 5554 4555, 0401 555 555)');
  }

  public validatePhonePlus(name: string, caption: string, validationFn?: ValidationFunction): boolean {
    let failed = typeof validationFn !== 'function' ? this.failsAUPhonePlus(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' must be a valid phone number (like 03 5554 4555, 0401 555 555, 1300 444 555)');
  }

  public validateMobile(name: string, caption: string, validationFn?: ValidationFunction): boolean {
    let failed = typeof validationFn !== 'function' ? this.failsAUMobilePhone(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' must be a valid mobile number (like 0401 555 555)');
  }

  failsMaxLength(value: any, max: number) {
    return value && value.length > max;
  }

  public validateMaxLength(name: string, caption: string, max: number, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsMaxLength(this.vm[name], max) : validationFn();
    return this.pushError(failed, name, caption + ' cannot be more than ' + max + ' characters');

  }

  failsMinLength(value: any, min: number) {
    return value && value.length < min;
  }

  public validateMinLength(name: string, caption: string, min: number, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsMinLength(this.vm[name], min) : validationFn();

    return this.pushError(failed, name, caption + ' cannot be less than ' + min + ' characters');
  }

  failsIsInteger(value: any) {
    return !value.toString().match(/^\d+$/);
  }

  public validateInteger(name: string, caption: string, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsIsInteger(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' must be a whole number');
  }

  failsIsNumber(value: any) {
    return !value.toString().match(/^\d+(.\d+)?$/);
  }

  public validateNumber(name: string, caption: string, validationFn?: ValidationFunction): boolean {

    let failed = typeof validationFn !== 'function' ? this.failsIsNumber(this.vm[name]) : validationFn();

    return this.pushError(failed, name, caption + ' must be a number');
  }

  failsMinValue(value: any, minValue: number) {
    return value && value < minValue;
  }
  public validateMinValue(name: string, caption: string, minValue: number, validationFn?: ValidationFunction): boolean {
    let failed = typeof validationFn !== 'function' ? this.failsMinValue(this.vm[name], minValue) : validationFn();

    return this.pushError(failed, name, caption + ' cannot be less than ' + minValue);
  }

  failsMaxValue(value: any, maxValue: number) {
    return value && value > maxValue;
  }

  public validateMaxValue(name: string, caption: string, maxValue: number, validationFn?: ValidationFunction): boolean {
    let failed = typeof validationFn !== 'function' ? this.failsMaxValue(this.vm[name], maxValue) : validationFn();

    return this.pushError(failed, name, caption + ' cannot be more than ' + maxValue);
  }



  public validateCustom(name: string, message: string, validationFn: ValidationFunction): boolean {

    let failed = validationFn();
    return this.pushError(failed, name, message);
  }

}

export class ValidationError {
  constructor(public fieldName: string, public message: string) { }
}

export interface IValidatedViewModel {
  errors: ValidationError[];
}

type ValidationFunction = () => boolean;